import { Wrapper, Text, Icon } from './ErrorMessage.style'

interface ErrorMessageProps {
  title: string
  icon?: boolean
}

const ErrorMessage = ({ title, icon = true, ...props }: ErrorMessageProps) => (
  <Wrapper {...props}>
    {icon && <Icon />}
    <Text>{title}</Text>
  </Wrapper>
)

export default ErrorMessage
